import { Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "@/auth/ProtectedRoute";
import { CallbackPage } from "@/auth/CallbackPage";
import { SilentRenewPage } from "@/auth/SilentRenewPage";
import { ConnectShell } from "@/features/ConnectShell";
import { GuestJoinPage } from "@/features/GuestJoinPage";
import { MeetingPage } from "@/features/MeetingPage";
import { RecordingSaveToasts } from "@/features/recording/RecordingSaveToasts";
import { StartFromLinkPage } from "@/features/start/StartFromLinkPage";

export function App() {
    return (
        <>
            <Routes>
                <Route path="/auth/callback" element={<CallbackPage />} />
                <Route path="/auth/silent-renew" element={<SilentRenewPage />} />
                {/* Anonymous guest join — no sign-in required. */}
                <Route path="/guest/:meetingId" element={<GuestJoinPage />} />
                {/* Signed-in meeting. The id stays in the URL so the link can
                    be shared and a refresh rejoins instead of dropping out. */}
                <Route
                    path="/meeting/:meetingId"
                    element={
                        <ProtectedRoute>
                            <MeetingPage />
                        </ProtectedRoute>
                    }
                />
                {/* FPT-8: other apps (Mail) start a chat or call here — /start/chat?with=… */}
                <Route
                    path="/start/:action"
                    element={
                        <ProtectedRoute>
                            <StartFromLinkPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="*"
                    element={
                        <ProtectedRoute>
                            <ConnectShell />
                        </ProtectedRoute>
                    }
                />
            </Routes>
            {/* Meeting recordings keep saving (with progress) after the host leaves the meeting. */}
            <RecordingSaveToasts />
        </>
    );
}
